import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=326b9d26&scoped=true&"
var script = {}
import style0 from "./impressum.vue?vue&type=style&index=0&id=326b9d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b9d26",
  null
  
)

export default component.exports